import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import type { ViewStyle } from 'react-native';

import Link from 'components/link';
import Picture from 'components/picture';
import { Box, BoxProps, withTypography } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, primitive, shadows, spacing } from 'styles/constants';

export const MAP_HEIGHT = '300px';

export const StyledLink = Link.withConfig({
  isInline: false,
  _text: {
    variant: 'copyOne',
    color: primitive.$fieryRed,
    fontSize: 'sm',
    lineHeight: 'sm',
    fontWeight: 'bold',
  },
  marginBottom: { base: '$4', md: '$12' },
  marginTop: { base: '$4', md: '$8' },
});

export const LocationContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    style: [styles.locationContainer, isDesktop && styles.locationContainerDesktop, style],
    ...props,
  });
};

export const StreetAddress = withTypography({
  variant: 'copyOne',
  fontSize: 'md',
  lineHeight: 'md',
  bold: true,
});

export const Address = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { style: [styles.address, style], ...props });

export const StyledPicture = Picture.withConfig({
  height: MAP_HEIGHT,
  width: 'full',
});

export const ServiceModeContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { style: [styles.serviceModeContainer, style], ...props });

export const ServiceModeIcon = (props: React.ComponentProps<typeof Icon>) =>
  React.createElement(Icon, {
    size: 'sm',
    lineHeight: '$6',
    color: primitive.$crunchyGreen,
    ...props,
  });

export const ServiceModeHeading = withTypography({
  variant: 'headerThreeLook',
  color: primitive.$crunchyGreen,
  style: {
    alignSelf: 'flex-end',
    margin: 0,
    marginLeft: spacing.$1,
  },
});

const styles = StyleSheet.create({
  address: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  locationContainer: {
    ...shadows.$1,
    backgroundColor: getDesignToken('background-card'),
    borderRadius: primitive.$borderRadius,
    marginBottom: spacing.$4,
    paddingHorizontal: spacing.$8,
    paddingVertical: spacing.$4,
    width: '100%',
  } as ViewStyle,
  locationContainerDesktop: {
    marginBottom: spacing.$12,
  },
  serviceModeContainer: {
    flexDirection: 'row',
    marginBottom: spacing.$0_5,
  },
});
